"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTracker = void 0;

var _client = _interopRequireDefault(require("./client"));

var createTracker = _client.default.createTracker;
exports.createTracker = createTracker;